/**
 * PP25 flash display — when the customer arrives from the post-purchase email
 * (?pp25=<expiry epoch seconds>), show 25%-off prices across the site plus a
 * countdown banner for the remainder of the 2-hour window.
 *
 * DISPLAY ONLY. The real discount is the unique, customer-locked, hard-expiring
 * code the email link auto-applies (/discount/CODE?...). If someone forges the
 * URL param they see pretty prices but pay full price at checkout.
 */
(function () {
  const COOKIE = 'pp25_until';

  function getUntil() {
    // URL param wins (fresh arrival from email), else cookie.
    const p = new URLSearchParams(location.search).get('pp25');
    if (p && /^\d{10}$/.test(p)) {
      document.cookie = COOKIE + '=' + p + ';path=/;max-age=7200;SameSite=Lax';
      return parseInt(p, 10) * 1000;
    }
    const m = document.cookie.match(new RegExp(COOKIE + '=(\\d{10})'));
    return m ? parseInt(m[1], 10) * 1000 : 0;
  }

  const until = getUntil();
  if (!until || until < Date.now()) return;

  // --- Price rewrite: strike-through original, show 25%-off in Stuburt blue ---
  const RATE = 0.75;
  const money = (n) =>
    '£' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');

  function rewrite(el) {
    if (el.dataset.pp25) return;
    // Offer excludes sale items: skip any price block already showing a
    // compare-at strikethrough or sale badge.
    const box = el.closest('.price, [class*="price"]') || el.parentElement;
    if (box && box.querySelector('s, del, [class*="compare"], [class*="sale"], [class*="badge"]')) return;
    const text = el.textContent.trim();
    const m = text.match(/^£\s?([\d,]+(?:\.\d{2})?)$/);
    if (!m) return;
    const orig = parseFloat(m[1].replace(/,/g, ''));
    if (!orig) return;
    el.dataset.pp25 = '1';
    el.innerHTML =
      '<s style="opacity:.45;margin-right:.4em">' + text + '</s>' +
      '<span style="color:#202945;font-weight:600">' + money(orig * RATE) + '</span>';
  }

  function sweep() {
    // Horizon price elements — verify selectors against the live theme at install.
    document
      .querySelectorAll('.price, [class*="price__regular"], [class*="price-item"], product-price')
      .forEach(rewrite);
  }

  // --- Countdown banner ---
  function banner() {
    const el = document.createElement('div');
    el.id = 'pp25-banner';
    el.style.cssText =
      'position:sticky;top:0;z-index:999;background:#202945;color:#fff;' +
      'text-align:center;padding:10px 16px;font-size:14px;letter-spacing:.02em';
    document.body.prepend(el);
    function tick() {
      const left = until - Date.now();
      if (left <= 0) {
        el.remove();
        document.cookie = COOKIE + '=;path=/;max-age=0';
        location.reload();
        return;
      }
      const mm = Math.floor(left / 60000);
      const ss = Math.floor((left % 60000) / 1000);
      el.textContent =
        'Thank you for your order — 25% off all full-price styles + free delivery for the next ' +
        mm + 'm ' + String(ss).padStart(2, '0') + 's. Applied automatically at checkout.';
      setTimeout(tick, 1000);
    }
    tick();
  }

  function init() {
    sweep();
    banner();
    new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
